export default "__VITE_ASSET__45dJ0_fb__"